(function () {
  "use strict";

  document.querySelectorAll("[data-nuvra-recommended]").forEach(initRecommended);

  function initRecommended(section) {
    var grid = section.querySelector("[data-recommended-grid]");
    var hint = section.querySelector("[data-recommended-hint]");
    var seedScript = document.getElementById(section.dataset.seedId || "");
    var limit = Math.max(4, Number(section.dataset.limit || 8));
    var seeds = [];

    if (seedScript) {
      try {
        seeds = JSON.parse(seedScript.textContent || "[]");
      } catch {
        seeds = [];
      }
    }

    function esc(str) {
      var d = document.createElement("div");
      d.textContent = str == null ? "" : String(str);
      return d.innerHTML;
    }

    function formatMoney(cents) {
      return "$" + (Number(cents) / 100).toFixed(2);
    }

    function sellerFromTags(tags) {
      var seller = "";
      var handle = "";
      (tags || []).forEach(function (tag) {
        if (tag.indexOf("seller:") === 0) {
          handle = tag.replace("seller:", "");
          seller = handle;
        }
      });
      return { seller: seller, handle: handle };
    }

    function bindCartButtons() {
      grid.querySelectorAll("[data-nuvra-add]").forEach(function (btn) {
        if (btn.dataset.bound === "1") return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", async function (e) {
          e.preventDefault();
          var id = this.dataset.variantId;
          if (!id) return;
          var original = this.textContent;
          this.textContent = "ADDING...";
          this.disabled = true;
          try {
            var res = await fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
            });
            this.textContent = res.ok ? "IN THE BAG ✓" : "OOPS";
            if (res.ok) document.dispatchEvent(new CustomEvent("cart:update"));
          } catch {
            this.textContent = "OOPS";
          }
          var self = this;
          setTimeout(function () {
            self.textContent = original;
            self.disabled = false;
          }, 2000);
        });
      });
    }

    function buildCard(product, opts) {
      opts = opts || {};
      var info = sellerFromTags(product.tags);
      var seller = info.seller || product.vendor || "Nuvra Vault";
      var sellerHandle = info.handle;
      var url = "/products/" + product.handle;
      var image =
        product.featured_image ||
        (product.images && product.images[0] ? product.images[0].src : "");
      var variant = product.variants && product.variants[0];
      var price = formatMoney(variant ? variant.price : 0);
      var compare =
        variant && variant.compare_at_price > variant.price
          ? '<s class="nuvra-listing__compare">' +
            formatMoney(variant.compare_at_price) +
            "</s>"
          : "";
      var stamp = opts.recentlyViewed
        ? '<span class="nuvra-listing__stamp nuvra-listing__stamp--viewed">Recently Viewed</span>'
        : opts.similar
          ? '<span class="nuvra-listing__stamp">Because You Viewed</span>'
          : "";
      var sellerLine = sellerHandle
        ? '<a href="/pages/shop?handle=' +
          encodeURIComponent(sellerHandle) +
          '" class="nuvra-listing__seller-name">Designed &amp; Sold by @' +
          esc(sellerHandle) +
          "</a>"
        : '<span class="nuvra-listing__seller-name">' + esc(seller) + "</span>";
      var cartBtn =
        product.variants && product.variants.length === 1 && variant && variant.available
          ? '<button type="button" class="nuvra-listing__cart-btn" data-nuvra-add data-variant-id="' +
            variant.id +
            '">Add to cart</button>'
          : '<a href="' +
            url +
            '" class="nuvra-listing__cart-btn nuvra-listing__cart-btn--link">View listing</a>';

      return (
        '<article class="nuvra-listing nuvra-reveal is-visible">' +
        '<div class="nuvra-listing__media">' +
        '<a href="' +
        url +
        '" class="nuvra-listing__img-link">' +
        (image
          ? '<img src="' + esc(image) + '" alt="' + esc(product.title) + '" class="nuvra-listing__img" loading="lazy">'
          : "") +
        "</a>" +
        stamp +
        "</div>" +
        '<div class="nuvra-listing__body">' +
        '<div class="nuvra-listing__seller">' +
        '<span class="nuvra-listing__seller-avatar">' +
        esc(seller.charAt(0)) +
        "</span>" +
        sellerLine +
        '<span class="nuvra-listing__stars" aria-hidden="true">★★★★★</span>' +
        "</div>" +
        '<h3 class="nuvra-listing__title"><a href="' +
        url +
        '">' +
        esc(product.title) +
        "</a></h3>" +
        '<div class="nuvra-listing__price-row"><span class="nuvra-listing__price">' +
        price +
        "</span>" +
        compare +
        "</div>" +
        cartBtn +
        "</div></article>"
      );
    }

    async function fetchProduct(handle) {
      if (!handle) return null;
      try {
        var res = await fetch("/products/" + encodeURIComponent(handle) + ".js", {
          cache: "no-store",
        });
        if (!res.ok) return null;
        return res.json();
      } catch {
        return null;
      }
    }

    function resolveViews() {
      var views = window.NuvraViews ? window.NuvraViews.getViews() : [];

      try {
        var legacy = JSON.parse(localStorage.getItem("viewedProducts") || "[]");
        legacy.forEach(function (id) {
          var seed = seeds.find(function (s) {
            return String(s.id) === String(id);
          });
          if (!seed) return;
          var exists = views.some(function (v) {
            return String(v.id) === String(id) || v.handle === seed.handle;
          });
          if (!exists) {
            views.push({ id: String(id), handle: seed.handle, viewedAt: 0 });
          }
        });
      } catch (_) {
        /* ignore */
      }

      views.sort(function (a, b) {
        return (b.viewedAt || 0) - (a.viewedAt || 0);
      });

      return views;
    }

    function handleList(views) {
      var handles = [];
      views.forEach(function (view) {
        if (view.handle && handles.indexOf(view.handle) === -1) {
          handles.push(view.handle);
          return;
        }
        if (view.id) {
          var seed = seeds.find(function (s) {
            return String(s.id) === String(view.id);
          });
          if (seed && seed.handle && handles.indexOf(seed.handle) === -1) {
            handles.push(seed.handle);
          }
        }
      });
      return handles;
    }

    async function render() {
      var views = resolveViews();
      var viewedHandles = handleList(views);

      if (!viewedHandles.length) {
        if (hint) hint.hidden = false;
        return;
      }

      if (hint) hint.hidden = true;

      var products = [];
      var viewedCount = 0;

      for (var i = 0; i < viewedHandles.length && products.length < limit; i++) {
        var product = await fetchProduct(viewedHandles[i]);
        if (product) {
          products.push({ product: product, recentlyViewed: true, similar: false });
          viewedCount += 1;
        }
      }

      if (products.length < limit) {
        var tagSet = {};
        products.forEach(function (row) {
          (row.product.tags || []).forEach(function (tag) {
            tagSet[tag.toLowerCase()] = true;
          });
        });

        var ranked = seeds
          .filter(function (seed) {
            return viewedHandles.indexOf(seed.handle) === -1;
          })
          .map(function (seed) {
            var tags = String(seed.tags || "")
              .split(",")
              .map(function (t) {
                return t.trim().toLowerCase();
              })
              .filter(Boolean);
            var score = tags.filter(function (t) {
              return tagSet[t];
            }).length;
            return { seed: seed, score: score };
          })
          .filter(function (row) {
            return row.score > 0;
          })
          .sort(function (a, b) {
            return b.score - a.score;
          });

        for (var j = 0; j < ranked.length && products.length < limit; j++) {
          var similar = await fetchProduct(ranked[j].seed.handle);
          if (
            similar &&
            !products.some(function (row) {
              return row.product.handle === similar.handle;
            })
          ) {
            products.push({ product: similar, recentlyViewed: false, similar: true });
          }
        }
      }

      if (!products.length) return;

      grid.innerHTML = products
        .map(function (row) {
          return (
            '<div class="nuvra-recommended__item" data-product-handle="' +
            esc(row.product.handle) +
            '" data-product-id="' +
            esc(row.product.id) +
            '">' +
            buildCard(row.product, {
              recentlyViewed: row.recentlyViewed,
              similar: row.similar,
            }) +
            "</div>"
          );
        })
        .join("");

      bindCartButtons();
    }

    render();
    document.addEventListener("nuvra:views-updated", render);
  }
})();
